(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["experaise-case-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.ch').forEach((root) => {
      const buttons = root.querySelectorAll('[data-ch-filter]');
      const cards = root.querySelectorAll('[data-ch-tags]');
      const count = root.querySelector('[data-ch-count]');
      buttons.forEach((btn) => btn.addEventListener('click', () => {
        const key = btn.dataset.chFilter;
        let shown = 0;
        buttons.forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
        cards.forEach((card) => {
          const ok = key === 'all' || card.dataset.chTags.split(',').includes(key);
          card.hidden = !ok;
          if (ok) shown += 1;
        });
        if (count) count.textContent = shown + (shown > 1 ? ' études de cas affichées.' : ' étude de cas affichée.');
      }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["experaise-cro-audit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-cr-tabs]').forEach(function (box) {
      var tabs = Array.prototype.slice.call(box.querySelectorAll('[role="tab"]'));
      function select(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (n) { e.preventDefault(); select(n); n.focus(); }
        });
      });
    });
    var fmt = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });
    document.querySelectorAll('[data-cr-sim]').forEach(function (sim) {
      function val(k) { return parseFloat(sim.querySelector('[data-cr-in="' + k + '"]').value); }
      function out(k, v) { var el = sim.querySelector('[data-cr-out="' + k + '"]'); if (el) el.textContent = v; }
      function update() {
        var sessions = val('sessions'), cvr = val('cvr'), aov = val('aov');
        var ca = sessions * cvr / 100 * aov;
        out('sessions', fmt.format(sessions));
        out('cvr', cvr.toFixed(1).replace('.', ',') + ' %');
        out('aov', fmt.format(aov) + ' €');
        out('ca', fmt.format(ca) + ' € / mois');
        out('s1', '+' + fmt.format(ca * 0.05) + ' €');
        out('s2', '+' + fmt.format(ca * 0.10) + ' €');
        out('s3', '+' + fmt.format(ca * 0.20) + ' €');
      }
      sim.querySelectorAll('[data-cr-in]').forEach(function (i) { i.addEventListener('input', update); });
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["experaise-header-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.eh3Ready === 'true') return;
      root.dataset.eh3Ready = 'true';
      const bar = root.querySelector('[data-eh3-bar]');
      const triggers = [...root.querySelectorAll('[data-eh3-trigger]')];
      const panelOf = (trigger) => document.getElementById(trigger.getAttribute('aria-controls'));
      const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      let current = null;
      let openTimer = null;
      let closeTimer = null;
      let openedByHover = 0;

      const hidePanel = (trigger, instant) => {
        const panel = panelOf(trigger);
        trigger.setAttribute('aria-expanded', 'false');
        panel.classList.remove('is-open');
        if (instant) panel.hidden = true;
        else window.setTimeout(() => { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 240);
      };
      const open = (trigger) => {
        window.clearTimeout(closeTimer);
        if (current === trigger) return;
        if (current) hidePanel(current, true);
        const panel = panelOf(trigger);
        panel.hidden = false;
        window.requestAnimationFrame(() => window.requestAnimationFrame(() => panel.classList.add('is-open')));
        trigger.setAttribute('aria-expanded', 'true');
        root.classList.add('has-panel');
        current = trigger;
      };
      const close = (focusBack) => {
        window.clearTimeout(openTimer);
        if (!current) return;
        const trigger = current;
        hidePanel(trigger, false);
        root.classList.remove('has-panel');
        current = null;
        if (focusBack) trigger.focus();
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          if (current === trigger && Date.now() - openedByHover > 400) close(false);
          else open(trigger);
        });
        trigger.addEventListener('pointerenter', () => {
          if (!finePointer.matches) return;
          window.clearTimeout(openTimer);
          openTimer = window.setTimeout(() => { if (current !== trigger) { openedByHover = Date.now(); open(trigger); } }, current ? 0 : 90);
        });
        trigger.addEventListener('pointerleave', () => window.clearTimeout(openTimer));
      });
      root.querySelectorAll('[data-eh3-direct]').forEach((link) => link.addEventListener('pointerenter', () => { if (finePointer.matches) close(false); }));
      bar.addEventListener('pointerleave', () => {
        if (!finePointer.matches) return;
        closeTimer = window.setTimeout(() => close(false), 200);
      });
      bar.addEventListener('pointerenter', () => window.clearTimeout(closeTimer));
      root.querySelector('[data-eh3-scrim]').addEventListener('click', () => close(false));
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && current) close(true); });
      document.addEventListener('pointerdown', (event) => { if (current && !bar.contains(event.target)) close(false); });
      root.addEventListener('focusout', (event) => { if (current && !root.contains(event.relatedTarget)) close(false); });

      const warm = () => root.querySelectorAll('.eh3-panel img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
      const nav = root.querySelector('.eh3-nav');
      if (nav) ['pointerenter', 'focusin'].forEach((type) => nav.addEventListener(type, warm, { once: true }));

      // Hors accueil, la barre reste opaque tant que l'emplacement d'origine de l'en-tête est visible :
      // sinon le fond clair de la page apparaît derrière les pilules pendant les premiers pixels de défilement.
      const onScroll = () => {
        const threshold = root.classList.contains('eh3--overlay') ? 8 : root.offsetHeight;
        root.classList.toggle('is-scrolled', window.scrollY > threshold);
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });

      const drawer = root.querySelector('[data-eh3-drawer]');
      const openButton = root.querySelector('[data-eh3-open]');
      const closeButton = root.querySelector('[data-eh3-close]');
      if (drawer && openButton && closeButton) {
        openButton.addEventListener('click', () => {
          if (typeof drawer.showModal === 'function') { drawer.showModal(); document.documentElement.style.overflow = 'hidden'; }
        });
        closeButton.addEventListener('click', () => drawer.close());
        drawer.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
        drawer.addEventListener('click', (event) => { if (event.target === drawer) drawer.close(); });
        drawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => drawer.close()));
      }
    };
    const boot = (scope = document) => scope.querySelectorAll('[data-eh3]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
    else boot();
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["experaise-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHeader = (root) => {
      if (!root || root.dataset.headerReady === 'true') return;
      root.dataset.headerReady = 'true';

      const details = [...root.querySelectorAll('[data-header-details]')];
      const dialog = root.querySelector('[data-menu-dialog]');
      const openButton = root.querySelector('[data-menu-open]');
      const closeButton = root.querySelector('[data-menu-close]');

      details.forEach((item) => item.addEventListener('toggle', () => {
        if (!item.open) return;
        details.forEach((other) => { if (other !== item) other.open = false; });
      }));

      document.addEventListener('pointerdown', (event) => {
        if (!root.contains(event.target)) details.forEach((item) => { item.open = false; });
      });

      if (!dialog || !openButton || !closeButton) return;
      openButton.addEventListener('click', () => {
        if (typeof dialog.showModal === 'function') dialog.showModal();
      });
      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => dialog.close()));
    };

    const boot = (scope = document) => scope.querySelectorAll('[data-experaise-header]').forEach(initHeader);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
    else boot();
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["experaise-journal-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-ea-root]');
    if (!root) return;
    var links = root.querySelectorAll('.ea-toc [data-ea-toc-link]');
    if (links.length && 'IntersectionObserver' in window) {
      var map = {};
      links.forEach(function (a) { map[decodeURIComponent(a.getAttribute('href').slice(1))] = a; });
      var current = null;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && map[e.target.id]) {
            if (current) current.removeAttribute('aria-current');
            current = map[e.target.id];
            current.setAttribute('aria-current', 'true');
          }
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      root.querySelectorAll('.ea-prose h2[id]').forEach(function (h) { io.observe(h); });
    }
    root.querySelectorAll('.ea-toc-mobile a').forEach(function (a) {
      a.addEventListener('click', function () { var d = a.closest('details'); if (d) d.open = false; });
    });
    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-ea-copy]');
      if (!btn || !navigator.clipboard) return;
      navigator.clipboard.writeText(btn.getAttribute('data-ea-copy')).then(function () {
        var label = btn.querySelector('[data-ea-copy-label]');
        if (!label) return;
        label.textContent = 'Lien copié';
        setTimeout(function () { label.textContent = 'Copier le lien'; }, 2000);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["experaise-offer-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-osp-card]').forEach(function (card) {
      if (!fine || calm) return;
      var raf = 0;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          card.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
          card.style.setProperty('--my', (y * 100).toFixed(1) + '%');
          card.style.setProperty('--rx', ((0.5 - y) * 4).toFixed(2) + 'deg');
          card.style.setProperty('--ry', ((x - 0.5) * 5).toFixed(2) + 'deg');
        });
      });
      card.addEventListener('pointerleave', function () {
        card.style.setProperty('--rx', '0deg'); card.style.setProperty('--ry', '0deg');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["experaise-offer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setPaused(root, paused) {
      root.classList.toggle('go--paused', paused);
      root.querySelectorAll('[data-go-pause]').forEach(function (btn) {
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        var label = btn.querySelector('[data-go-pause-label]');
        if (label) label.textContent = paused ? 'Relancer les animations' : 'Mettre les animations en pause';
      });
    }
    document.addEventListener('click', function (event) {
      var pause = event.target.closest('[data-go-pause]');
      if (pause) {
        var root = pause.closest('[data-go-root]');
        if (root) setPaused(root, !root.classList.contains('go--paused'));
        return;
      }
      var nav = event.target.closest('[data-go-scroll]');
      if (nav) {
        var section = nav.closest('section');
        var track = section && section.querySelector('[data-go-track]');
        if (!track) return;
        var card = track.querySelector('.go-work');
        var step = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
        track.scrollBy({ left: step * Number(nav.getAttribute('data-go-scroll')), behavior: 'smooth' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["experaise-p2-evidence"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-p2-evidence]').forEach((root) => {
      root.querySelectorAll('[data-exp-filter]').forEach((button) => {
        button.addEventListener('click', () => {
          root.querySelectorAll('[data-exp-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
          root.querySelectorAll('[data-exp-card]').forEach((card) => {
            card.hidden = button.dataset.expFilter !== 'all' && card.dataset.category !== button.dataset.expFilter;
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["experaise-p2-tool"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const euro = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
    const number = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });
    const decimal = new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    const safe = (value, fallback = 0) => Math.max(Number(value) || fallback, 0);
    const download = (filename, content) => {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(new Blob([content], { type: 'text/plain;charset=utf-8' }));
      link.download = filename;
      link.click();
      URL.revokeObjectURL(link.href);
    };

    document.querySelectorAll('[data-p2-tool]').forEach((root) => {
      const mode = root.dataset.mode;

      if (mode === 'cro') {
        const form = root.querySelector('[data-cro-form]');
        const update = () => {
          const sessions = safe(root.querySelector('[data-cro-sessions]').value);
          const rate = safe(root.querySelector('[data-cro-rate]').value);
          const aov = safe(root.querySelector('[data-cro-aov]').value);
          const target = safe(root.querySelector('[data-cro-target]').value);
          const margin = Math.min(safe(root.querySelector('[data-cro-margin]').value), 100);
          const currentOrders = sessions * rate / 100;
          const extraOrders = Math.max(sessions * target / 100 - currentOrders, 0);
          const extraRevenue = extraOrders * aov;
          const uplift = rate > 0 ? Math.max((target / rate - 1) * 100, 0) : 0;
          root.querySelector('[data-cro-current-orders]').textContent = number.format(currentOrders);
          root.querySelector('[data-cro-orders]').textContent = `+${number.format(extraOrders)}`;
          root.querySelector('[data-cro-revenue]').textContent = `+${euro.format(extraRevenue)}`;
          root.querySelector('[data-cro-profit]').textContent = `+${euro.format(extraRevenue * margin / 100)}`;
          root.querySelector('[data-cro-uplift]').textContent = `+${decimal.format(uplift)} %`;
        };
        form.addEventListener('input', update); update();
      }

      if (mode === 'budget') {
        const form = root.querySelector('[data-budget-form]');
        const values = { creation:[7000,12000,7], redesign:[9000,17000,9], migration:[12000,24000,11], plus:[20000,42000,15] };
        const extras = {
          catalog:{ small:[0,0,0], medium:[1800,3500,1], large:[4500,9000,3] },
          design:{ adapted:[0,0,0], custom:[2500,5000,2], editorial:[5500,10000,4] },
          markets:{ one:[0,0,0], two:[1600,3500,1], many:[4000,8000,3] },
          integrations:{ light:[0,0,0], medium:[2200,5000,2], heavy:[6000,13000,4] },
          features:{ standard:[0,0,0], advanced:[3000,7000,2], complex:[8000,18000,5] }
        };
        let latest = '';
        const update = () => {
          const type = root.querySelector('[data-budget-type]').value;
          let [min,max,weeks] = values[type];
          ['catalog','design','markets','integrations','features'].forEach((key) => {
            const value = root.querySelector(`[data-budget-${key}]`).value;
            const addition = extras[key][value]; min += addition[0]; max += addition[1]; weeks += addition[2];
          });
          const spread = max - min;
          const level = spread > 22000 ? 'Architecture complexe' : spread > 11000 ? 'Intermédiaire' : 'Maîtrisé';
          const priority = type === 'migration' ? 'Audit données & SEO' : type === 'plus' ? 'Architecture fonctionnelle' : 'Cadrage & architecture';
          root.querySelector('[data-budget-range]').textContent = `${euro.format(min)} — ${euro.format(max)}`;
          root.querySelector('[data-budget-duration]').textContent = `${weeks} à ${weeks + 4} semaines`;
          root.querySelector('[data-budget-level]').textContent = level;
          root.querySelector('[data-budget-priority]').textContent = priority;
          latest = `ESTIMATION SHOPIFY — EXPERAISE\n\nFourchette indicative : ${euro.format(min)} à ${euro.format(max)}\nDurée : ${weeks} à ${weeks + 4} semaines\nComplexité : ${level}\nPriorité : ${priority}\n\nHors abonnements, licences d’apps, production photo et acquisition. Cette estimation ne constitue pas un devis.\nhttps://experaise.com/pages/contact`;
        };
        form.addEventListener('change', update);
        root.querySelector('[data-budget-download]').addEventListener('click', () => download('estimation-budget-shopify-experaise.txt', latest));
        update();
      }

      if (mode === 'migration') {
        const form = root.querySelector('[data-migration-form]');
        const update = () => {
          const total = [...root.querySelectorAll('[data-migration-question]')].reduce((sum, item) => sum + Number(item.value), 0);
          const score = Math.round(total / 16 * 100);
          let status = 'Préparation insuffisante';
          let advice = 'Commencez par l’inventaire des données, des URLs et des intégrations critiques.';
          if (score >= 75) { status = 'Prêt pour le cadrage final'; advice = 'Validez la recette, le rollback et le monitoring avant de fixer le go-live.'; }
          else if (score >= 45) { status = 'Migration cadrable'; advice = 'Le socle existe. Fermez maintenant les zones partielles avant le développement.'; }
          root.querySelector('[data-migration-score]').textContent = score;
          root.querySelector('[data-migration-bar]').style.width = `${score}%`;
          root.querySelector('[data-migration-status]').textContent = status;
          root.querySelector('[data-migration-advice]').textContent = advice;
        };
        form.addEventListener('change', update); update();
      }

      if (mode === 'scorecard') {
        const form = root.querySelector('[data-scorecard-form]');
        let report = '';
        const update = () => {
          const items = [...root.querySelectorAll('[data-score-item]')];
          items.forEach((item) => item.closest('label').querySelector('output').textContent = item.value);
          const total = items.reduce((sum, item) => sum + Number(item.value), 0);
          const score = Math.round(total / 50 * 100);
          const weakest = [...items].sort((a,b) => Number(a.value) - Number(b.value))[0];
          const status = score >= 80 ? 'Système prêt à scaler' : score >= 60 ? 'Base saine à optimiser' : score >= 40 ? 'Fondations à consolider' : 'Risques prioritaires';
          root.querySelector('[data-scorecard-score]').textContent = score;
          root.querySelector('[data-scorecard-bar]').style.width = `${score}%`;
          root.querySelector('[data-scorecard-status]').textContent = status;
          root.querySelector('[data-scorecard-priority]').textContent = weakest.dataset.scoreItem;
          report = `SCORECARD SHOPIFY — EXPERAISE\n\nScore global : ${score}/100\nNiveau : ${status}\nPriorité : ${weakest.dataset.scoreItem}\n\n${items.map((item) => `${item.dataset.scoreItem} : ${item.value}/5`).join('\n')}\n\nAuto-évaluation indicative. Pour un audit vérifié : https://experaise.com/pages/contact`;
        };
        form.addEventListener('input', update);
        root.querySelector('[data-scorecard-download]').addEventListener('click', () => download('scorecard-shopify-experaise.txt', report));
        root.querySelector('[data-scorecard-print]').addEventListener('click', () => window.print());
        update();
      }

      if (mode === 'cms') {
        const form = root.querySelector('[data-cms-form]');
        const update = () => {
          const scores = { Shopify:70, PrestaShop:50, WooCommerce:50, Magento:38, Wix:38 };
          const team = root.querySelector('[data-cms-team]').value;
          const catalog = root.querySelector('[data-cms-catalog]').value;
          const priority = root.querySelector('[data-cms-priority]').value;
          const maintenance = root.querySelector('[data-cms-maintenance]').value;
          const channel = root.querySelector('[data-cms-channel]').value;
          if (team === 'low') { scores.Shopify += 20; scores.Wix += 16; scores.Magento -= 18; }
          if (team === 'high') { scores.Magento += 15; scores.WooCommerce += 12; scores.PrestaShop += 12; }
          if (catalog === 'complex') { scores.Magento += 22; scores.PrestaShop += 15; scores.Wix -= 20; }
          if (catalog === 'variants') { scores.Shopify += 12; scores.PrestaShop += 8; }
          if (priority === 'speed') { scores.Shopify += 18; scores.Wix += 10; }
          if (priority === 'control') { scores.WooCommerce += 16; scores.PrestaShop += 15; scores.Magento += 12; }
          if (priority === 'content') { scores.WooCommerce += 20; scores.Wix += 8; }
          if (priority === 'enterprise') { scores.Magento += 24; scores.Shopify += 14; }
          if (maintenance === 'low') { scores.Shopify += 18; scores.Wix += 15; scores.Magento -= 15; }
          if (maintenance === 'internal') { scores.Magento += 10; scores.WooCommerce += 10; scores.PrestaShop += 10; }
          if (channel === 'retail') scores.Shopify += 18;
          if (channel === 'b2b') { scores.Magento += 15; scores.Shopify += 10; scores.PrestaShop += 8; }
          if (channel === 'content') scores.WooCommerce += 16;
          const ranking = Object.entries(scores).map(([name,score]) => [name, Math.max(0, Math.min(score,100))]).sort((a,b) => b[1]-a[1]);
          root.querySelector('[data-cms-ranking]').innerHTML = ranking.map(([name,score]) => `<div class="p2tool__rank-row"><span>${name}</span><i><b style="width:${score}%"></b></i><b>${score}</b></div>`).join('');
          root.querySelector('[data-cms-advice]').textContent = `${ranking[0][0]} ressort pour ce contexte. Vérifiez ensuite le coût total, les intégrations et les contraintes de gouvernance.`;
        };
        form.addEventListener('change', update); update();
      }

      if (mode === 'maturity') {
        const form = root.querySelector('[data-maturity-form]');
        const update = () => {
          const items = [...root.querySelectorAll('[data-maturity-question]')];
          const total = items.reduce((sum,item) => sum + Number(item.value), 0);
          const stage = total >= 13 ? 4 : total >= 9 ? 3 : total >= 5 ? 2 : 1;
          const titles = {1:'Fondations',2:'Traction',3:'Optimisation',4:'Scale'};
          const advice = {1:'Fiabilisez l’offre, la mesure et le socle technique avant d’accélérer.',2:'Stabilisez l’acquisition et le parcours avant de multiplier les canaux.',3:'Installez une cadence d’expérimentation et de priorisation transverse.',4:'Industrialisez l’apprentissage, l’international et la gouvernance data.'};
          const weakest = [...items].sort((a,b) => Number(a.value)-Number(b.value)).slice(0,3).map((item) => item.dataset.area);
          root.querySelector('[data-maturity-stage]').textContent = stage;
          root.querySelector('[data-maturity-title]').textContent = titles[stage];
          root.querySelector('[data-maturity-advice]').textContent = advice[stage];
          root.querySelector('[data-maturity-priorities]').innerHTML = [...new Set(weakest)].map((item) => `<span>${item}</span>`).join('');
        };
        form.addEventListener('change', update); update();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["experaise-portfolio"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-pf-filter]').forEach(function (box) {
      var chips = box.querySelectorAll('[data-pf-cat]');
      var items = box.querySelectorAll('[data-pf-item]');
      var count = box.querySelector('[data-pf-count]');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var cat = chip.getAttribute('data-pf-cat'); var n = 0;
          chips.forEach(function (c) { var on = c === chip; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          items.forEach(function (it) { var show = cat === 'all' || it.getAttribute('data-pf-item') === cat; it.hidden = !show; if (show) n++; });
          if (count) count.textContent = n;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-blog-reel]').forEach((reel) => {
    if (reel.dataset.ready === 'true') return;
    const track = reel.querySelector('[data-blog-reel-track]');
    if (!track || track.children.length < 2) return;

    reel.dataset.ready = 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let offset = 0;
    let halfWidth = 0;
    let dragging = false;
    let dragStarted = false;
    let startX = 0;
    let startOffset = 0;
    let lastX = 0;
    let lastTime = 0;
    let velocity = 0;
    let previousFrame = performance.now();

    const measure = () => {
      halfWidth = track.scrollWidth / 2;
    };

    const normalize = () => {
      if (!halfWidth) return;
      while (offset <= -halfWidth) offset += halfWidth;
      while (offset > 0) offset -= halfWidth;
    };

    const render = () => {
      track.style.transform = `translate3d(${offset}px, 0, 0)`;
    };

    const animate = (time) => {
      const delta = Math.min(time - previousFrame, 34);
      previousFrame = time;
      if (!dragging && !reducedMotion) {
        if (Math.abs(velocity) > 0.08) {
          offset += velocity * (delta / 16.67);
          velocity *= 0.94;
        } else {
          velocity = 0;
          offset -= 0.42 * (delta / 16.67);
        }
        normalize();
        render();
      }
      requestAnimationFrame(animate);
    };

    reel.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      dragging = true;
      dragStarted = false;
      startX = event.clientX;
      startOffset = offset;
      lastX = event.clientX;
      lastTime = performance.now();
      velocity = 0;
      reel.classList.add('is-dragging');
      reel.setPointerCapture(event.pointerId);
    });

    reel.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const movement = event.clientX - startX;
      if (Math.abs(movement) > 5) dragStarted = true;
      offset = startOffset + movement;
      const now = performance.now();
      const elapsed = Math.max(now - lastTime, 1);
      velocity = ((event.clientX - lastX) / elapsed) * 16.67;
      lastX = event.clientX;
      lastTime = now;
      normalize();
      render();
    });

    const release = (event) => {
      if (!dragging) return;
      dragging = false;
      reel.classList.remove('is-dragging');
      if (reel.hasPointerCapture(event.pointerId)) reel.releasePointerCapture(event.pointerId);
    };

    reel.addEventListener('pointerup', release);
    reel.addEventListener('pointercancel', release);
    reel.addEventListener('click', (event) => {
      if (!dragStarted) return;
      event.preventDefault();
      event.stopPropagation();
      dragStarted = false;
    }, true);

    new ResizeObserver(measure).observe(track);
    track.querySelectorAll('img').forEach((image) => image.addEventListener('load', measure, { once: true }));
    measure();
    render();
    requestAnimationFrame(animate);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-benchmarks-2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.eb26').forEach((benchmark) => {
      benchmark.querySelectorAll('[data-sector-filter]').forEach((button) => {
        button.addEventListener('click', () => {
          benchmark.querySelectorAll('[data-sector-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
          benchmark.querySelectorAll('[data-sector-row]').forEach((row) => {
            row.hidden = button.dataset.sectorFilter !== 'all' && row.dataset.sectorRow !== button.dataset.sectorFilter;
          });
        });
      });
    });

    const calculators = document.querySelectorAll('[data-benchmark-calculator]');

    calculators.forEach((calculator) => {
      const sessionsInput = calculator.querySelector('[data-benchmark-sessions]');
      const ordersInput = calculator.querySelector('[data-benchmark-orders]');
      const aovInput = calculator.querySelector('[data-benchmark-aov]');
      const targetInput = calculator.querySelector('[data-benchmark-target]');
      const currentOutput = calculator.querySelector('[data-benchmark-current]');
      const gapOutput = calculator.querySelector('[data-benchmark-gap]');
      const ordersGainOutput = calculator.querySelector('[data-benchmark-orders-gain]');
      const revenueOutput = calculator.querySelector('[data-benchmark-revenue]');
      const meter = calculator.querySelector('[data-benchmark-meter]');
      const marker = calculator.querySelector('[data-benchmark-marker]');
      const percentFormatter = new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const numberFormatter = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });
      const currencyFormatter = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });

      const update = () => {
        const sessions = Math.max(Number(sessionsInput.value) || 0, 0);
        const orders = Math.max(Number(ordersInput.value) || 0, 0);
        const averageOrderValue = Math.max(Number(aovInput.value) || 0, 0);
        const target = Math.max(Number(targetInput.value) || 0, 0);
        const current = sessions > 0 ? (orders / sessions) * 100 : 0;
        const gap = current - target;
        const potentialOrders = Math.max(Math.round((sessions * target) / 100 - orders), 0);
        const potentialRevenue = potentialOrders * averageOrderValue;
        const scaleMaximum = Math.max(target, current, 6);
        const currentWidth = Math.min((current / scaleMaximum) * 100, 100);
        const targetPosition = Math.min((target / scaleMaximum) * 100, 100);

        currentOutput.textContent = `${percentFormatter.format(current)} %`;
        gapOutput.textContent = `${gap >= 0 ? '+' : '−'}${percentFormatter.format(Math.abs(gap))} pt`;
        ordersGainOutput.textContent = `+${numberFormatter.format(potentialOrders)}`;
        revenueOutput.textContent = `+${currencyFormatter.format(potentialRevenue)}`;
        meter.style.width = `${currentWidth}%`;
        marker.style.left = `${targetPosition}%`;
      };

      calculator.addEventListener('input', update);
      calculator.addEventListener('change', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-cro-project-stack"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cro-project-stack]').forEach((stack) => {
    const cards = Array.from(stack.querySelectorAll('[data-cro-project-card]'))
    if (!cards.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
    let ticking = false
    const update = () => {
      const desktop = window.matchMedia('(min-width: 901px)').matches
      cards.forEach((card, index) => {
        if (!desktop) {
          card.style.transform = ''
          return
        }
        const next = cards[index + 1]
        if (!next) {
          card.style.transform = 'scale(1)'
          return
        }
        const start = 150 + index * 22
        const progress = Math.min(1, Math.max(0, (start - next.getBoundingClientRect().top) / 360))
        const scale = 1 - progress * .025
        card.style.transform = `scale(${scale})`
      })
      ticking = false
    }
    const requestUpdate = () => {
      if (ticking) return
      ticking = true
      requestAnimationFrame(update)
    }
    window.addEventListener('scroll', requestUpdate, { passive: true })
    window.addEventListener('resize', requestUpdate, { passive: true })
    update()
  })

  } catch(e) { console.error(e); }
})();
})();
